export var DiscountCodeTypes;
(function (DiscountCodeTypes) {
    DiscountCodeTypes["PERCENTAGE"] = "percentage";
    DiscountCodeTypes["NUMBER"] = "number";
    DiscountCodeTypes["FREE_DELIVERY"] = "freeDelivery";
    DiscountCodeTypes["BUY_X_GET_Y"] = "buyXGetY";
    DiscountCodeTypes["FREE_ITEM"] = "freeItem";
})(DiscountCodeTypes || (DiscountCodeTypes = {}));
export var BuyAndGetConditionsTypes;
(function (BuyAndGetConditionsTypes) {
    BuyAndGetConditionsTypes["PERCENTAGE"] = "percentage";
    BuyAndGetConditionsTypes["FREE"] = "free";
})(BuyAndGetConditionsTypes || (BuyAndGetConditionsTypes = {}));
export var PaymentMethodsEnum;
(function (PaymentMethodsEnum) {
    PaymentMethodsEnum["Cash"] = "cash";
    PaymentMethodsEnum["Card"] = "card";
    PaymentMethodsEnum["Delivery"] = "delivery";
    PaymentMethodsEnum["Transfer"] = "transfer";
})(PaymentMethodsEnum || (PaymentMethodsEnum = {}));
export var OrderStatusEnum;
(function (OrderStatusEnum) {
    OrderStatusEnum["CREATED"] = "created";
    OrderStatusEnum["REQUESTED"] = "requested";
    OrderStatusEnum["PICKUP"] = "pickup";
    OrderStatusEnum["PICKINGUP"] = "pickingup";
    OrderStatusEnum["PENDING_STORE_RECEPTION_VALIDATION"] = "pending_store_reception_validation";
    OrderStatusEnum["CLEANING"] = "cleaning";
    OrderStatusEnum["READY"] = "ready";
    OrderStatusEnum["DELIVERY"] = "delivery";
    OrderStatusEnum["DELIVERING"] = "delivering";
    OrderStatusEnum["COLLECTED"] = "collected";
    OrderStatusEnum["CANCELLED"] = "cancelled";
    OrderStatusEnum["UNCOLLECTED"] = "uncollected";
})(OrderStatusEnum || (OrderStatusEnum = {}));
export var OrderProductLineStatus;
(function (OrderProductLineStatus) {
    OrderProductLineStatus["Created"] = "created";
    OrderProductLineStatus["Cleaning"] = "cleaning";
    OrderProductLineStatus["Ready"] = "ready";
    OrderProductLineStatus["Collected"] = "collected";
    OrderProductLineStatus["Uncollected"] = "uncollected";
    OrderProductLineStatus["Cancelled"] = "cancelled";
})(OrderProductLineStatus || (OrderProductLineStatus = {}));
